import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../AppHooks";
import { _settings_customer } from "../../../AppSettings";
import { setLastLocation, setLastLocationUnauthenticated } from "../../../slices/UserSlice";
import { checkSizeIsMobile } from "../Common";
import ServerNotification from "../utilities/ServerNotification";
import { LeftMenu } from "./LeftMenu";

interface IHeader {
    title?: string;
}

const Header = ({
    title = "Lostine Drone Co"
}: IHeader) => {
    const [currentTime, setCurrentTime] = useState(new Date().toLocaleTimeString());
    const [isMenuOpen, setIsMenuOpen] = useState(true);
    const [isMobile, setIsMobile] = useState(false);
    const [noticeBanner, setNoticeBanner] = useState('');
    const navigate = useNavigate();
    const [currentRoute, setCurrentRoute] = useState('');
    const location = useLocation();
    const isLoggedIn = useAppSelector(state => state.users.isLoggedIn);
    const dispatch = useAppDispatch();
    const showHeaderVideo = false;
    const isLoginPage = location.pathname === '/login' || location.pathname === '/login/verify';
    const isAboutPage = location.pathname === '/about' || location.pathname === '/about-v2';

    const handleMenu = () => {
        setIsMenuOpen((prevState) => !prevState);
    };

    useEffect(() => {
        // Check if mobile
        setIsMobile(checkSizeIsMobile(window.innerWidth));

        const interval = setInterval(() => {
            setCurrentTime(new Date().toLocaleTimeString());
        }, 10000);
        return () => clearInterval(interval);
    }, []);

    // Check which page we're on and set the notice accordingly
    useEffect(() => {
        // Use array at _settings_customer.NOTICE_BANNERs to get correct notice based on page location. Then assign to noticeBanner
        const page = window.location.pathname;
        const notice = _settings_customer.NOTICE_BANNERS.filter((item) => item.location === page);
        setNoticeBanner(notice[0]?.title ? notice[0].title : '');

        // Set last location while logged in, in redux
        if (isLoggedIn) {
            // Take user to last location if it doesn't match the current location
            if (location.pathname !== '/login' && location.pathname !== '/login/verify') {
                dispatch(setLastLocation(location.pathname));
            } else {
                dispatch(setLastLocation('/dashboard'));
            }
            if (location.pathname.includes('/settings')) {
                // Hide logo on settings page
                document.querySelector('.app-header img').classList.add('hidden-img');
            } else {
                document.querySelector('.app-header img').classList.remove('hidden-img');
            }
        } else {
            // Set unauthenticated last location
            dispatch(setLastLocationUnauthenticated(location.pathname));
        }
    }, [location]);

    return (
        <>
            <header className={`app-header ${showHeaderVideo ? 'has-hero-video' : 'no-hero-video'} ${isLoginPage ? 'login-page' : ''} ${isAboutPage ? 'about-page' : ''}`}>
                {showHeaderVideo && (
                    <video
                        className="app-header-video"
                        autoPlay
                        loop
                        muted
                        playsInline
                        aria-hidden="true"
                    >
                        <source src="/assets/video/Welge-Roadhouse-Flyover-Short-Version.mp4" type="video/mp4" />
                    </video>
                )}
                <LeftMenu isMenuOpen={isMenuOpen} setIsMenuOpen={setIsMenuOpen} />
                <div className="menu-hamburger">
                    {/* <GiHamburgerMenu onClick={handleMenu} /> */}
                    {/* <Button
                        props={{
                            text: "Back",
                            onClick: () => { navigate(-1) },
                            classes: "app-header-back-button"
                        }}
                    /> */}
                    {/* <motion.i 
                        className="fas fa-sync-alt" 
                        onClick={() => { window.location.reload() }}
                        style={{
                            fontSize: '.8em'
                        }}
                        whileHover={{
                            rotate: 180,
                            transition: {
                                duration: .5
                            }
                        }}
                    /> */}
                </div>
                {!isMobile && (
                    <>
                        <img
                            className="app-logo"
                            src={require("../../files/logo/final/Lostine-Drone-Co-Logo-Primary--full-color-on-white.png")} 
                            alt="Lostine Drone Co Logo" 
                            onClick={ () => { navigate('/') } }
                            style={{
                                cursor: 'pointer',
                                height: location.pathname !== '/' ? '128px' : '192px'
                            }}
                        />
                        {/* <h1>{title}</h1> */}
                        {/* <div className="app-time">
                            {new Date().toLocaleDateString() + ' ' + currentTime.slice(0, -6) + ' ' + currentTime.slice(-2)}
                        </div>    */}
                    </>
                )}
                {noticeBanner && (
                    <div className="app-notice-banner">
                        <div className="app-notice-banner-text">
                            <div className="app-notice-banner-text-body">
                                <><span style={{color: 'red'}}>Notice: </span>{noticeBanner}</>
                            </div>
                        </div>
                    </div>
                )}
                <ServerNotification />
            </header>
            {/* <LeftMenu isMenuOpen={isMenuOpen} setIsMenuOpen={setIsMenuOpen} /> */}
            {/* <Dimmer isOpen={isMenuOpen} setOtherComponentViewable={setIsMenuOpen} zIndex={2000} />  */}
        </>
    );
}

export default Header;